<template>
  <div class="app_detail_container">
    <PageTitle
      :title="title"
      :showFileBtn="true"
      backPath="AppMailRecords"
      :menuArgs="menuArgs"
      @clickFileBtn="clickFileBtn"
    />
    <div class="app_menu_main">
      <PageDetailDivider ref="PageDetailDividerRef" title="主表信息" />
      <div class="app_menu_main_form">
        <el-form :rules="rules" :model="form">
          <el-form-item label="寄件人" prop="sender">
            <el-input placeholder="关联获取" readonly v-model="form.sender" />
          </el-form-item>
          <el-form-item label="寄件日期" prop="ship_date">
            <el-input placeholder="关联获取" v-date readonly v-model="form.ship_date" />
          </el-form-item>
          <el-form-item label="寄件内容" prop="contribution_details">
            <el-input type="textarea" :rows="5" placeholder="关联获取" readonly v-model="form.contribution_details" />
          </el-form-item>
          <el-form-item label="快递公司" prop="courier_company">
            <el-input placeholder="关联获取" readonly v-model="form.courier_company" />
          </el-form-item>
          <el-form-item label="是否加急" prop="is_expedited">
            <el-input placeholder="关联获取" readonly v-model="form.is_expedited" />
          </el-form-item>
          <el-form-item label="收件单位" prop="receiving_company">
            <el-input type="textarea" :rows="5" placeholder="关联获取" readonly v-model="form.receiving_company" />
          </el-form-item>
          <el-form-item label="收件人" prop="recipient">
            <el-input placeholder="关联获取" readonly v-model="form.recipient" />
          </el-form-item>
          <el-form-item label="快递单号" prop="express_number" v-if="form.document_status === 9">
            <el-input placeholder="关联获取" readonly v-model="form.express_number" />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <PageDetailBtns ref="PageDetailBtnsRef" menuPath="MailRecords" :parentData="this" @handleClick="handleClickBtn" />
    <!-- 附件 -->
    <PageDetailFile ref="PageDetailFileRef" :ID="id" vuePath="MailRecords" />

    <!-- 确认dialog -->
    <ConfirmModal ref="ConfirmModalRef" @confirm="sureConfirm" />
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageDetailBtns from '@/components/app/PageDetailBtns.vue'
import PageDetailDivider from '@/components/app/PageDetailDivider.vue'
import PageDetailFile from '@/components/app/PageDetailFile.vue'
import ConfirmModal from '@/components/app/ConfirmModal.vue'

export default {
  components: {
    PageTitle,
    PageDetailBtns,
    PageDetailDivider,
    ConfirmModal,
    PageDetailFile
  },
  data() {
    return {
      id: -1,
      title: '邮寄明细',
      formVisible: false,
      // 表单
      form: {
        id: 0,
        creator_id: 0,
        creator: '',
        createTime: '',
        dept_name: '',
        report_approve_id: 0,
        sender: '',
        ship_date: '',
        contribution_details: '',
        courier_company: '',
        is_expedited: '',
        recipient: '',
        receiving_company: '',
        document_status: 0,
        express_number: '',
        last_modify_time: ''
      },
      rules: {
        sender: [
          { required: true, message: '请选择寄件人', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        ship_date: [{ required: true, message: '请输入寄件日期', trigger: 'change' }],
        contribution_details: [
          { required: true, message: '请输入寄件内容', trigger: 'change' },
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        courier_company: [
          { required: true, message: '请输入快递公司', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        is_expedited: [],
        recipient: [
          { required: true, message: '请输入收件人', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '长度在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        receiving_company: [
          { required: true, message: '请输入收件单位', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ]
      },
      // 下拉框
      ComBoxItems: {
        company: []
      },
      // 展示金额
      showMoney: true,
      menuArgs: ''
    }
  },
  mounted() {
    this.id = this.$route.query.id

    this.BindText()

    this.menuArgs = this.$route.query.menuArgs
  },
  methods: {
    // 确认
    async sureConfirm(code) {
      if (code === 'refuse') {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'leaderReview') {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'unReview') {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      }
    },
    // 调用审批接口
    async sureReview(flag = false, approve_opinions = '') {
      const { data: res } = await this.$http.put('/Finance/Mail_records/audit', [
        {
          id: this.id,
          manager_review: flag,
          approve_opinions
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/Finance/Mail_records/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/Finance/Mail_records/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    leaderReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    refuse() {
      this.$confirm('是否确认拒绝?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'unReview':
          // this.unReview()
          this.$refs.ConfirmModalRef.openDialog('unReview')
          break
        case 'faReview':
        case 'financialReview':
        case 'managerReview':
        case 'leaderReview':
          // this.leaderReview()
          this.$refs.ConfirmModalRef.openDialog('leaderReview')
          break
        case 'refuse':
          // this.refuse()
          this.$refs.ConfirmModalRef.openDialog('refuse')
          break
        case 'close':
          this.formVisible = false
          break
      }
    },
    // 绑定数据
    async BindText() {
      const that = this
      const { data: res } = await that.$http.get('/Finance/Mail_records', {
        params: {
          id: that.id
        }
      })
      if (res.isSuccess) {
        that.form = res.data
      }
    },
    // 点击附件按钮
    clickFileBtn() {
      this.$refs.PageDetailFileRef.openDialog()
    },
    showModal() {},
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    // 选择人员
    handleSelect() {},
    // 主表选择框值改变为空时
    clearFormToNull(type) {
      switch (type) {
        case '':
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

.app_detail_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    // background-color: #fafafa;

    overflow: auto;

    box-sizing: border-box;
    // padding: 0 20px;
    // padding-top: 10px;
    // padding-bottom: 20px;

    /deep/ .el-form-item__label {
      padding: 0 !important;
      font-size: 20px !important;
      font-weight: 500;
      color: #a78897;
    }
    /deep/ .el-input__inner {
      border: 0 !important;
      border-bottom: 1px solid #d1d1d1 !important;
      border-radius: 0;
      padding-left: 0 !important;
      transition: all 0.3s;
      // background-color: #fafafa;
      font-size: 18px !important;
    }

    /deep/ .el-textarea__inner {
      font-size: 18px !important;
    }

    // /deep/ .el-input__inner:hover {
    //   padding-left: 10px !important;
    //   transition: all 0.3s;
    // }
    /deep/ .el-input__inner:focus {
      padding-left: 10px !important;
      transition: all 0.3s;
    }

    .app_menu_main_form {
      box-sizing: border-box;
      padding: 0 20px 20px 20px;
    }
  }
}
.file-list-container {
  // box-sizing: border-box;
  padding: 10px;

  height: 30px;
}
</style>
